import script from "./vue-clazy-load.vue?vue&type=script&setup=true&lang=ts"
export * from "./vue-clazy-load.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__